"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

/**
 * CSS-based loading animation
 * Renders a div with the 'icon-loading-animation' class that uses CSS animations
 * This is preferred over SVG-based loading spinners for simple loading states
 */
var Loader = function Loader() {
  return (0, _preact.h)("div", {
    className: "icon-loading-animation"
  });
};

var _default = Loader;
exports.default = _default;